/* src/universities/Scene.js */

import React from 'react';

import UniversityCard from './cards/UniversityCard'
import AddUniversityCard from './cards/AddUniversityCard'

class Universities extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, mode: 'add'};
    this._toggleAddCard = this._toggleAddCard.bind(this);
  }

  _toggleAddCard(type) {
    return mode => this.setState({ open: type, mode });
  }

  render() {
    const { open, mode } = this.state;
    return (
      <React.Fragment>
        <UniversityCard onOpen={this._toggleAddCard(true)} />
        <AddUniversityCard
          open={open}
          onClose={this._toggleAddCard(false)}
          mode={mode}
        />
      </React.Fragment>
    );
  }
}

export default Universities;



// WEBPACK FOOTER //
// ./src/modules/universities/Scene.js